import type { MockWebBridge } from '@m43/bridge-interface';

declare global {
    interface Window {
        mockWebBridge?: MockWebBridge;
    }
}

export const mockWebBridge = window.mockWebBridge;
